import React from 'react';
import ReactDOM from 'react-dom/client';
import './shopify-theme.css';  // Import Shopify theme matching styles first
import './index.css';
import App from './App';
import { initShopifyGuard } from './shopify-guard';
import { initMarketsConfig } from './config';

async function bootstrap() {
  await initMarketsConfig();

  if (!initShopifyGuard()) {
    return;
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

bootstrap();
